import { Card } from '../card';
import styles from './index.module.scss';

const Notifications = () => {
  const data = [
    {
      title: 'Background Notifications',
      data: [
        {
          key: '1',
          title: 'System Notifications',
          extra: (
            <Switch
              disabled
              checked
              onChange={(e) => {
                console.log(e);
              }}
            />
          ),
        },
        {
          key: '2',
          title: 'Display Preview',
          extra: (
            <Switch
              disabled
              checked
              onChange={(e) => {
                console.log(e);
              }}
            />
          ),
        },
        {
          key: '3',
          title: 'Voice & Video Call Alerts',
          extra: (
            <Switch
              disabled
              checked
              onChange={(e) => {
                console.log(e);
              }}
            />
          ),
        },
      ],
    },
    // {
    //   title: 'In-App Notifications',
    //   data: [
    //     {
    //       icon: <>1</>,
    //       key: '1',
    //       title: 'Notifications',
    //       description: 'Notifications',
    //       extra: (
    //         <Switch
    //           onChange={(e) => {
    //             console.log(e);
    //           }}
    //         />
    //       ),
    //     },
    //     {
    //       icon: <>2</>,
    //       key: '2',
    //       title: 'Notificatiosns',
    //       extra: (
    //         <Switch
    //           onChange={(e) => {
    //             console.log(e);
    //           }}
    //         />
    //       ),
    //     },
    //     {
    //       icon: <>2</>,
    //       key: '3',
    //       title: 'Notifications',
    //       extra: (
    //         <Switch
    //           onChange={(e) => {
    //             console.log(e);
    //           }}
    //         />
    //       ),
    //     },
    //   ],
    // },
    // {
    //   title: 'Display Notifications',
    //   data: [
    //     {
    //       icon: <>1</>,
    //       key: '1',
    //       title: 'Notifications',
    //       description: 'Notifications',
    //       extra: (
    //         <Switch
    //           onChange={(e) => {
    //             console.log(e);
    //           }}
    //         />
    //       ),
    //     },
    //     {
    //       icon: <>2</>,
    //       key: '2',
    //       title: 'Notificatiosns',
    //       extra: (
    //         <Switch
    //           onChange={(e) => {
    //             console.log(e);
    //           }}
    //         />
    //       ),
    //     },
    //     {
    //       icon: <>2</>,
    //       key: '3',
    //       title: 'Notifications',
    //       extra: (
    //         <Switch
    //           onChange={(e) => {
    //             console.log(e);
    //           }}
    //         />
    //       ),
    //     },
    //   ],
    // },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.title}>Notifications and Sounds</div>
      <div className={styles.content}>
        {data.map((item, index) => {
          return (
            <Card
              className={styles.card}
              key={index}
              title={item.title}
              data={item.data}
            ></Card>
          );
        })}
      </div>
    </div>
  );
};
export default Notifications;
